export const avatarImgBaseUrl = process.env.REACT_APP_AVATARS_BASE_URL
  ? process.env.REACT_APP_AVATARS_BASE_URL
  : "http://dev.corev2.cuideo.com";
